import {Component, Inject, OnDestroy, OnInit, PLATFORM_ID} from '@angular/core';
import {AppLeague} from '@shared/models/league';
import {DatePipe} from '@angular/common';
import {ActivatedRoute, Router} from '@angular/router';
import {HomeRoutes} from '@app/routes/home.routes';
import {User} from '@app/shared/models/user';
import {UserService} from '@app/core/services/user.service';
import {Subscription} from 'rxjs';
import {MatTabChangeEvent} from '@angular/material/tabs';
import {SEOService} from '@core/services/seo.service';
import {HomeRoutesMetadata} from '@shared/models/seo/home-routes-metadata';


@Component({
  selector: 'app-games',
  templateUrl: './games.component.html',
  styleUrls: ['./games.component.scss'],
  providers: [DatePipe]
})
export class GamesComponent implements OnInit, OnDestroy {

  public selectedLeagueInAllMatches: AppLeague = null;
  public isLoading = true;
  public showAllGames: boolean;
  public datesForSelection: Date[] = [];
  public selectedDate = new Date();
  public today = new Date();
  public user: User;
  public user$: Subscription;
  public gameUrl: string;

  constructor(
    private seoService: SEOService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private datePipe: DatePipe,
    private userService: UserService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  public ngOnInit(): void {
    this.user$ = this.userService.currentUserSubject.subscribe(user => {
      if (this.user?._id === user?._id) {
        return;
      }
      this.user = user;
    })
    this.showAllGames = !this.router.url.includes(HomeRoutes.games.rootPersonal);
    this.gameUrl = this.showAllGames ? HomeRoutes.games.root : HomeRoutes.games.rootPersonal;
    this.gameUrl += '/';
    const paramDate = this.activatedRoute.snapshot.params.parsedDate;
    if (paramDate === 'heute') {
      this.selectedDate = this.today;
    } else {
      const dateString = paramDate.split('-').reverse().join('-');
      this.selectedDate = new Date(dateString);
      this.setMetadataForDate(paramDate);
    }

    this.setDatesForSelection();
    this.isLoading = false;
  }

  public setMetadataForDate(date: string): void {
    const readableDate = date.split('-').join('.');
    const metaData = HomeRoutesMetadata[HomeRoutes.games.relative.date];
    const title = metaData.title.replace('{{date}}', readableDate);
    const description = metaData.description.replace('{{date}}', readableDate);
    this.seoService.setTitle(title);
    this.seoService.setDescription(description);
    this.seoService.setCanonicalTagForUrl();
  }

  public ngOnDestroy(): void {
    this.user$?.unsubscribe();
  }

  public changeRoute(tab: MatTabChangeEvent): void {
    if (tab.tab.textLabel === 'Alle Spiele') {
      this.router.navigateByUrl(HomeRoutes.games.relative.today);
    } else if (tab.tab.textLabel === 'Meine Spiele') {
      this.router.navigateByUrl(HomeRoutes.games.relative.personalToday);
    }
  }

  public setDatesForSelection() {
    this.datesForSelection = [];
    // 4 dates in each direction left and right
    for (let i = -4; i <= 4; i++) {
      const date: Date = new Date(this.selectedDate.getTime());
      date.setDate(date.getDate() + i);
      this.datesForSelection.push(date);
    }
  }

  public isSameDay(d1: Date, d2: Date): boolean {
    return d1.getDate() === d2.getDate() &&
           d1.getMonth() === d2.getMonth() &&
           d1.getFullYear() === d2.getFullYear();
  }

  public getLinkForDate(date: Date): string {
    if (this.isSameDay(date, this.today)) {
      return `/${this.gameUrl}/heute`;
    } else {
      const dateString = this.datePipe.transform(date, 'dd-MM-y');
      return `/${this.gameUrl}/${dateString}`;
    }
  }

  public selectDate(date: Date) {
    if (this.isSameDay(date, this.selectedDate)) {
      return;
    }
    this.selectedDate = date;
    this.setDatesForSelection();

    if (!this.isSameDay(date, this.today)) {
      const dateString = this.datePipe.transform(date, 'dd-MM-y');
      this.setMetadataForDate(dateString);
    }
  }
}
